import { useContext } from 'react';
import { createContext } from 'react';

import { ProductIdentifierProps } from '../@types/ProductIdentifierProps';

export const ProductIdentifierContext = createContext<ProductIdentifierProps>({} as ProductIdentifierProps);

ProductIdentifierContext.displayName = 'ProductIdentifier';

const ProductIdentifierProvider = (props: ProductIdentifierProps) => (
	<ProductIdentifierContext.Provider value={props}>{props.children}</ProductIdentifierContext.Provider>
);

export const useProductIdentifier = () => {
	const context = useContext(ProductIdentifierContext);

	return context;
};

export default ProductIdentifierProvider;
